import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import {
  fetchGetInfrastructure,
  IGetInfrastructureRequest,
  IGetInfrastructureResponse,
  IGetInfrastructureResponse200,
  IGetInfrastructureResponse400,
} from '../../../repositories/newbuilding-card/v1/get-infrastructure';
import { ResponseError } from '../../../utils/errors';

export const getInfrastructureItems = async (newbuildingId: number): Promise<IGetInfrastructureResponse> => {
  try {
    const response = await fetchGetInfrastructure<IGetInfrastructureResponse200, IGetInfrastructureResponse400>({
      httpApi: getHttpApi(),
      parameters: { newbuildingId, removeExistingOnDuplicate: true } as IGetInfrastructureRequest,
      config: {
        requestConfig: { withCredentials: true },
      },
    });

    if (response.statusCode === 400) {
      const { message } = response.response;

      throw new ResponseError({
        domain: 'Map#getInfrastructureItems()',
        message: message as string,
      });
    }

    return response.response;
  } catch (error) {
    getLogger().error(error, {
      newbuildingId,
      domain: 'getStats',
    });

    return { infrastructure: [] };
  }
};
